module.exports = __webpack_public_path__ + "static/media/gallery6.17dc5152.webp";